export enum AttackAttribute {
  KeyPass = 841,
}
